<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <Box theme="box-primary" title="Tìm kiếm">
          <div slot="custombtn">
            <button id="popover-config-search" class="btn btn-box-tool">
              <i class="fa fa-cog" aria-hidden="true"></i>
            </button>
            <b-popover :show.sync="showConfigSearch" target="popover-config-search" title="Cấu hình hiển thị"
                       triggers="hover">
              <b-table :items="configSearchItems" responsive :fields="configFields">
                <template v-slot:cell(key)="data">
                  <b-form-checkbox v-model="data.item.show"
                                   @change="toggleColumnSearchForm($event, data.item.key)"></b-form-checkbox>
                </template>
                <template v-slot:cell(label)="data">
                  {{ data.item.label }}
                </template>
              </b-table>
            </b-popover>
          </div>
          <div slot="content">
            <div v-show="isShowSearch('phone_number')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Số thành viên</label>
              <input type="text" class="form-control" v-model="filterData.phone_number" v-on:keyup.enter="search"
                     placeholder="Nhập tên số thành viên..."/>
            </div>
            <div v-show="isShowSearch('pickup_date')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Ngày lấy</label>
              <date-picker v-model="filterData.pickup_date" range valueType="format"></date-picker>
            </div>
            <div v-show="isShowSearch('locked_date')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Ngày khoá số</label>
              <date-picker v-model="filterData.locked_date" range valueType="format"></date-picker>
            </div>
            <div v-show="isShowSearch('lock_count')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Số lần khóa</label>
              <div class="d-flex">
              <multiselect v-model="filterData.lock_count_type" :options="lock_count_type_list" :multiple="true"
                           :close-on-select="true"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
              <multiselect v-model="filterData.number_of_locked" :options="number_of_locked_list" :multiple="false"
                           :close-on-select="true"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
              </div>
            </div>
            <div v-show="isShowSearch('provider')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Nhà cung cấp</label>
              <multiselect v-model="filterData.provider" :options="providersList" :multiple="true"
                           :close-on-select="false"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
            </div>
            <div v-show="isShowSearch('main_phone_number')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Số chủ</label>
              <multiselect v-model="filterData.main_phone_number" :options="mainPhoneNumberList" :multiple="true"
                           :close-on-select="false"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
            </div>
            <div v-show="isShowSearch('client_use_date')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Ngày khách lấy</label>
              <date-picker v-model="filterData.client_use_date" range valueType="format"></date-picker>
            </div>
            <div v-show="isShowSearch('legal')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Pháp nhân</label>
              <multiselect v-model="filterData.legal" :options="legalList" :multiple="true"
                           :close-on-select="false"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
            </div>
            <div v-show="isShowSearch('phone_status')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Trạng thái số</label>
              <multiselect v-model="filterData.phone_status" id="ajax1" label="name" track-by="code"
                           placeholder="Nhập để tìm kiếm người dùng"
                           open-direction="bottom" :options="groupStatus" :multiple="true" :searchable="true"
                           group-label="label" group-values="status" :group-select="true"
                           select-group-label="Chọn tất cả" deselect-group-label="Bỏ chọn tất cả"
                           :loading="loadingStatus" :internal-search="true" :clear-on-select="true"
                           :close-on-select="false" :options-limit="300" :limit="numberOfUser" :max-height="600"
                           :show-no-results="false" :hide-selected="false">
              </multiselect>
            </div>
            <div v-show="isShowSearch('has_fee_date')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Ngày phát sinh chi phí</label>
              <date-picker v-model="filterData.has_fee_date" range valueType="format"></date-picker>
            </div>
            <div v-show="isShowSearch('cancel_date')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Ngày huỷ số</label>
              <date-picker v-model="filterData.cancel_date" range valueType="format"></date-picker>
            </div>
            <div v-show="isShowSearch('viettel_using_status')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Trạng thái sử dụng Viettel</label>
              <multiselect v-model="filterData.viettel_using_status" :options="usingStatusList" :multiple="false"
                           :close-on-select="true"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
            </div>
            <div v-show="isShowSearch('mobifone_using_status')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Trạng thái sử dụng Mobifone</label>
              <multiselect v-model="filterData.mobifone_using_status" :options="usingStatusList" :multiple="false"
                           :close-on-select="true"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
            </div>
            <div v-show="isShowSearch('vinaphone_using_status')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Trạng thái sử dụng Vinaphone</label>
              <multiselect v-model="filterData.vinaphone_using_status" :options="usingStatusList" :multiple="false"
                           :close-on-select="true"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
            </div>
            <div v-show="isShowSearch('other_using_status')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Trạng thái sử dụng Ngoại mạng</label>
              <multiselect v-model="filterData.other_using_status" :options="usingStatusList" :multiple="false"
                           :close-on-select="true"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
            </div>
            <div v-show="isShowSearch('viettel_unlocking_status')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Trạng thái khóa số Viettel</label>
              <multiselect v-model="filterData.viettel_unlocking_status" :options="unlockingStatusList" :multiple="false"
                           :close-on-select="true"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
            </div>
            <div v-show="isShowSearch('mobifone_unlocking_status')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Trạng thái khóa số Mobifone</label>
              <multiselect v-model="filterData.mobifone_unlocking_status" :options="unlockingStatusList" :multiple="false"
                           :close-on-select="true"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
            </div>
            <div v-show="isShowSearch('vinaphone_unlocking_status')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Trạng thái khóa số Vinaphone</label>
              <multiselect v-model="filterData.vinaphone_unlocking_status" :options="unlockingStatusList" :multiple="false"
                           :close-on-select="true"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
            </div>
            <div v-show="isShowSearch('other_unlocking_status')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Trạng thái khóa số Ngoại mạng</label>
              <multiselect v-model="filterData.other_unlocking_status" :options="unlockingStatusList" :multiple="false"
                           :close-on-select="true"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
            </div>
            <div v-show="isShowSearch('pics')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Nhân viên kĩ thuật</label>
              <multiselect v-model="filterData.pics" id="ajax1" label="name" track-by="code"
                           placeholder="Nhập để tìm kiếm người dùng"
                           open-direction="bottom" :options="groupUser" :multiple="true" :searchable="true"
                           group-label="label" group-values="users" :group-select="true"
                           select-group-label="Chọn tất cả" deselect-group-label="Bỏ chọn tất cả"
                           :loading="loadingUser" :internal-search="true" :clear-on-select="true"
                           :close-on-select="false" :options-limit="300" :limit="numberOfUser" :max-height="600"
                           :show-no-results="false" :hide-selected="false">
              </multiselect>
            </div>
            <div v-show="isShowSearch('sale_pics')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Nhân viên chăm sóc</label>
              <multiselect v-model="filterData.sale_pics" id="ajax" label="name" track-by="code"
                           placeholder="Nhập để tìm kiếm người dùng"
                           open-direction="bottom" :options="groupSaleUser" :multiple="true" :searchable="true"
                           select-group-label="Chọn tất cả" deselect-group-label="Bỏ chọn tất cả"
                           group-label="label" group-values="users" :group-select="true"
                           :loading="loadingSaleUser" :internal-search="true" :clear-on-select="false"
                           :close-on-select="false" :options-limit="300" :limit="2" :max-height="600"
                           :show-no-results="false" :hide-selected="false" :disabled="disableSearchPic">
              </multiselect>
            </div>
            <div v-show="isShowSearch('customer')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>KH sử dụng</label>
<!--              <multiselect v-model="filterData.customer" :options="phoneClientsList" :multiple="true"-->
<!--                           :close-on-select="false" :limit="3" placeholder="Vui lòng chọn"-->
<!--                           label="text" track-by="value"></multiselect>-->
              <multiselect v-model="filterData.customers" id="ajax" label="name" track-by="code"
                           placeholder="Nhập để tìm kiếm KH sử dụng"
                           open-direction="bottom" :options="groupCustomers" :multiple="true" :searchable="true"
                           select-group-label="Chọn tất cả" deselect-group-label="Bỏ chọn tất cả"
                           group-label="label" group-values="customers" :group-select="true"
                           :loading="loadingCustomer" :internal-search="true" :clear-on-select="false"
                           :close-on-select="false" :options-limit="300" :limit="2" :max-height="600"
                           :show-no-results="false" :hide-selected="false">
              </multiselect>
            </div>
            <div v-show="isShowSearch('fee_type')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Loại phí</label>
              <multiselect v-model="filterData.fee_type" :options="fee_type_list" :multiple="true"
                           :close-on-select="false"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
            </div>
            <div v-show="isShowSearch('device')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Thiết bị</label>
              <input type="text" class="form-control" v-model="filterData.device" v-on:keyup.enter="search"
                     placeholder="Nhập thiết bị..."/>
            </div>
            <div v-show="isShowSearch('port')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Port</label>
              <input type="text" class="form-control" v-model="filterData.port" v-on:keyup.enter="search"
                     placeholder="Nhập port..."/>
            </div>
          </div>
          <div slot="footer">
            <div class="d-flex justify-content-end align-items-center">
              <b-button v-if="!this.isTechnicalStaff" variant="danger" @click="addPhoneNumber" class="mr-2" :disabled="!isEditable || isTechnicalStaff"
                        style="margin-top: 25px"><span
                class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                Thêm mới
              </b-button>
              <b-button variant="primary" @click="bulkUpdateSelectedStatus" class="mr-2" :disabled="!isEditable"
                        style="margin-top: 25px"><span
                class="fa fa-exchange" aria-hidden="true"></span>
                Chuyển trạng thái lựa chọn
              </b-button>
              <b-button v-if="isAdmin" variant="danger" @click="markDeleteSelected" class="mr-2" :disabled="!isEditable"
                        style="margin-top: 25px"><span
                class="fa fa-exchange" aria-hidden="true"></span>
                Xóa số lựa chọn
              </b-button>
              <b-button variant="warning" @click="bulkUpdateStatus" class="mr-2" :disabled="!isEditable"
                        style="margin-top: 25px"><span
                class="fa fa-exchange" aria-hidden="true"></span>
                Chuyển trạng thái tất cả
              </b-button>
              <b-button variant="info" @click="exportPhoneNumber" class="mr-2" style="margin-top: 25px"
                        :disabled="!isEditable"><span
                class="glyphicon glyphicon-export" aria-hidden="true"></span>
                Export
              </b-button>
              <b-button variant="secondary" @click="copyAllPhoneNumber" class="mr-2" style="margin-top: 25px">
                <span class="glyphicon glyphicon-copy" aria-hidden="true"></span>
                Copy tất cả SĐT
              </b-button>
              <b-button variant="success" @click="search" style="margin-top: 25px">
                <span class="glyphicon glyphicon-search" aria-hidden="true"></span>Tìm kiếm
              </b-button>
            </div>
          </div>
        </Box>
      </div>

      <div class="col-md-12 col-sm-12 col-xs-12">
        <Box theme="box-primary" title="Danh sách số điện thoại">
          <div slot="custombtn">
            <button id="popover-config-table" class="btn btn-box-tool">
              <i class="fa fa-cog" aria-hidden="true"></i>
            </button>
            <b-popover :show.sync="showConfigTable" target="popover-config-table" title="Cấu hình hiển thị"
                       triggers="hover">
              <b-table :items="configItems" responsive :fields="configFields">
                <template v-slot:cell(key)="data">
                  <b-form-checkbox v-model="data.item.show"
                                   @change="toggleColumn($event, data.item.key)"></b-form-checkbox>
                </template>
                <template v-slot:cell(label)="data">
                  {{ data.item.label }}
                </template>
              </b-table>
            </b-popover>
          </div>
          <div slot="content">
            <b-table bordered outlined hover responsive :busy="loading" :fields="fields" :items="items" show-empty
                     :select-mode="'multi'"
                     ref="selectableTable"
                     @row-dblclicked="onDoubleClicked"
                     selectable
                     @row-selected="onRowSelected"
            >

              <template #table-busy>
                <div class="text-center my-2 mt-5 mb-5">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Đang tải...</strong>
                </div>
              </template>

              <template #empty="scope">
                <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
              </template>
              <template #head(row_selected)="data">
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="checkAll"
                  @change="onCheckAll"
                  name="checkbox-1"
                  value="check_all"
                  unchecked-value="uncheck_all"
                >
                </b-form-checkbox>
              </template>

              <template v-slot:cell(row_selected)="data">
                <div class="d-flex justify-content-center flex-column align-items-center">
                  <b-form-group>
                    <b-form-checkbox type="checkbox" v-model="data.rowSelected"
                                     @change="toggleRow(data)"></b-form-checkbox>
                  </b-form-group>
                </div>
              </template>
              <template v-slot:cell(phone_number)="data">
                <span @click="onClickPhoneNumber(data.item.phone_number)">{{data.item.phone_number}}</span>
              </template>
              <template v-slot:cell(main_phone_number)="data">
                <ColorTags v-if="data.item.main_phone_number" :tags="generateTag(buildMainPhoneNumber(data.item.main_phone_number))" :size="'md'"></ColorTags>
              </template>
              <template v-slot:cell(provider)="data">
                <ColorTags v-if="data.item.provider" :tags="generateTag(buildProvider(data.item.provider))" :size="'md'"></ColorTags>
              </template>
              <template v-slot:cell(legal)="data">
                <ColorTags v-if="data.item.legal" :tags="generateTag(buildLegal(data.item.legal))" :size="'md'"></ColorTags>
              </template>
              <template v-slot:cell(phone_number_client)="data">
                <ColorTags v-if="data.item.phone_number_client" :tags="generateTag(buildPhoneClient(data.item.phone_number_client))" :size="'md'"></ColorTags>
              </template>
              <template v-slot:cell(phone_number_status)="data">
                <ColorTags v-if="data.item.phone_number_status" :tags="generateTag(buildStatus(data.item.phone_number_status))" :size="'md'"></ColorTags>
              </template>
              <template v-slot:cell(pickup_date)="data">
                <span>{{data.item.pickup_date | format_date}}</span>
              </template>
              <template v-slot:cell(client_use_date)="data">
                <span>{{data.item.client_use_date | format_date}}</span>
              </template>
              <template v-slot:cell(lock_provider)="data">
                <span>{{getLockProviderList(data.item)}}</span>
              </template>
              <template v-slot:cell(open_provider)="data">
                <span>{{getOpenProviderList(data.item)}}</span>
              </template>
              <template v-slot:cell(using_provider)="data">
                <span>{{getUsingProviderList(data.item)}}</span>
              </template>
              <template v-slot:cell(sale_pics)="data">
                <span>{{ getSaleName(data.item) }}</span>
              </template>
              <template v-slot:cell(pic_id)="data">
                <span>{{ getTechnicalStaffName(data.item) }}</span>
              </template>
              <template v-slot:cell(lock_histories)="data">
                <LockSummary v-if="data.item.lock_histories.length > 0" :phoneNumberLockHistories="data.item.lock_histories" :phone-number="data.item" />
              </template>
            </b-table>
          </div>
          <div slot="footer">
            <div><strong>Tổng phí: </strong>
              <label>Phí khởi tạo({{ statistic.total_init_fee | format_currency }})</label>
              <label>, Phí vận hành({{ statistic.total_operate_fee | format_currency }})</label>
              <label>, Phí mở({{ statistic.total_open_fee | format_currency }})</label>
              <label>, Phí khác({{ statistic.total_other_fee | format_currency }})</label>
            </div>
            <div><strong>Tuổi thọ trung bình : </strong><label>{{ statistic.age_avg.toFixed(2) }} ngày</label></div>
            <div><strong>Nhân viên : </strong><label>{{ getTechnicalStaffStatistic() }}</label></div>
            <div><strong>Tổng kho số: </strong><label>{{ totalRow }}</label></div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="page-size-container">
                <span>Hiển thị</span>
                <b-form-select
                  id="pageSize"
                  v-model="pageSize"
                  :options="pageSizes"
                  required
                ></b-form-select>
                <span>  dòng</span>
              </div>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="pageSize"
                aria-controls="my-table"
              ></b-pagination>
            </div>
          </div>
        </Box>
      </div>
    </section>

    <b-modal size='xl' id="phoneNumberDetail" hide-footer title="Thông tin số" @hide="() => this.filter()"
             header-class="crm-modal">
      <div class="col-md-12 col-sm-12 col-xs-12 mb-5">
        <PhoneNumberDetail :id="selectedId" :hide-modal="hideModal" :move-status-list="moveStatusList" :is-technical-staff="isTechnicalStaff"></PhoneNumberDetail>
      </div>
    </b-modal>

    <b-modal size='xl' id="bulkUpdateModal" hide-footer title="Cập nhật trạng thái hàng loạt">
      <div class="form-group col-md-12 col-sm-12 col-xs-12">
        <label>Trạng thái số</label>
        <div class="d-flex">
          <multiselect v-model="bulkUpdateStatusData" :options="moveStatusList" :multiple="false"
                       :close-on-select="true" :limit="1"
                       placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
        </div>
        <div v-if="bulkUpdateStatusData && (bulkUpdateStatusData.text === 'Đang nghi ngờ' || bulkUpdateStatusData.text === 'Đang sử dụng')" class="mt-5">
          <label>Chọn mạng</label>
          <div class="d-flex flex-row align-items-center mb-1">
            <div class="d-flex flex-row align-items-center mb-1">
              <b-form-checkbox style="width: 150px" id="checkbox-viettel" v-model="bulkUpdateStatusProvider.Viettel" name="Viettel">Viettel
              </b-form-checkbox>
            </div>
            <div class="d-flex align-items-center mb-1">
              <b-form-checkbox style="width: 150px" id="checkbox-mobifone" v-model="bulkUpdateStatusProvider.Mobifone" name="Mobifone">Mobifone
              </b-form-checkbox>
            </div>
            <div class="d-flex align-items-center mb-1">
              <b-form-checkbox style="width: 150px" id="checkbox-vinaphone" v-model="bulkUpdateStatusProvider.Vinaphone" name="Vinaphone">Vinaphone
              </b-form-checkbox>
            </div>
            <div class="d-flex align-items-center">
              <b-form-checkbox style="width: 150px" id="checkbox-other" v-model="bulkUpdateStatusProvider.Other" name="Other">Ngoại mạng</b-form-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="pull-right mt-3">
          <b-button variant="success" class="w-150px" @click="saveBulkUpdate" :disabled="!isEditable">Lưu</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal size='xl' id="importModal" hide-footer title="Nhập số điện thoại hàng loạt">
      <div class="form-group col-md-12 col-sm-12 col-xs-12">
        <label>Chọn file</label>
        <div class="d-flex">
          <b-form-file
            v-model="importFile"
            :state="Boolean(importFile)"
            accept="text/xlsx"
            placeholder="Chọn file xlsx hoặc thả vào đây..."
            drop-placeholder="Thả file vào đây..."
            required
          ></b-form-file>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="pull-right mt-3">
          <b-button variant="success" class="w-150px" @click="handleImportPhoneNumber">Lưu</b-button>
          <b-button variant="secondary" class="w-150px" @click="closeImportModal">Đóng</b-button>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import Box from '../../components/Box.vue'
import {
  FEE_TYPE_LIST,
  LOCAL_STORAGE_KEY, LOCK_COUNT_TYPE, MAX_SALE_USER_NUMBER,
  NUMBER_OF_LOCKED_LIST,
  PERMISSION_KEY, PROVIDERS, STATUS_PHONE_NUMBER
} from '../../common/constant'
import DatePicker from 'vue2-datepicker'
import Multiselect from '../../lib/vue-multiple-select/Multiselect.vue'
import Utils from '../../common/utils'
import PhoneNumberDetail from './PhoneNumberDetail.vue'
import LegalAPI from '../../api/legalApi'
import MainPhoneNumberAPI from '../../api/mainPhoneNumber'
import PhoneNumberAPI from '../../api/phoneNumberApi'
import PhoneNumberClientAPI from '../../api/phoneNumberClientApi'
import PhoneNumberProviderAPI from '../../api/providerApi'
import PhoneNumberStatusAPI from '../../api/phoneNumberStatusApi'
import ColorTags from '../../components/ColorTags.vue'
import UserApi from '../../api/user'
import LockSummary from './LockSummary.vue'
import {mapGetters} from 'vuex'
import moment from 'moment'

export default {
  name: 'PhoneNumberManagementList',
  components: {
    Box,
    DatePicker,
    Multiselect,
    PhoneNumberDetail,
    ColorTags,
    LockSummary
  },
  data () {
    return {
      filterData: {
        client_use_date: null,
        pickup_date: [moment().subtract(7, 'day').format('yyyy-MM-DD'), moment().format('yyyy-MM-DD')],
        locked_date: null,
        cancel_date: null,
        has_fee_date: null,
        phone_number: '',
        main_phone_number: '',
        phone_status: [],
        phone_number_avg_age: 0,
        number_of_locked: NUMBER_OF_LOCKED_LIST[0],
        lock_count_type: [],
        fee_type: null,
        provider: null,
        customer: null,
        customers: [],
        legal: null,
        pics: [],
        sale_pics: [],
        open_telcos: [],
        using_telcos: [],
        lock_telcos: [],
        viettel_using_status: null,
        mobifone_using_status: null,
        vinaphone_using_status: null,
        other_using_status: null,
        viettel_unlocking_status: null,
        mobifone_unlocking_status: null,
        vinaphone_unlocking_status: null,
        other_unlocking_status: null,
        device: null,
        port: null
      },
      bulkUpdateStatusProvider: {
        Viettel: false,
        Mobifone: false,
        Vinaphone: false,
        Other: false
      },
      usingStatusList: [
        {text: 'Mạng mở', value: 'OPEN'},
        {text: 'Mạng bị khóa', value: 'LOCK'},
        {text: 'Mạng đang sử dụng', value: 'USING'}
      ],
      unlockingStatusList: [
        {text: 'Đã mở', value: 'OPENED'},
        {text: 'Đã gửi NCC', value: 'SENT_PROVIDER'},
        {text: 'NCC báo sai', value: 'WRONG_REPORT'}
      ],
      telcoList: PROVIDERS,
      lock_count_type_list: LOCK_COUNT_TYPE,
      number_of_locked_list: NUMBER_OF_LOCKED_LIST,
      fee_type_list: FEE_TYPE_LIST,
      lockHistories: {},
      showConfigSearch: false,
      configFields: [
        {
          key: 'key',
          label: 'Hiển thị'
        }, {
          key: 'label',
          label: 'Cột'
        }
      ],
      configSearchItems: [
        {
          key: 'pickup_date',
          label: 'Ngày lấy',
          show: true
        },
        {
          key: 'client_use_date',
          label: 'Ngày khách lấy',
          show: true
        },
        {
          key: 'locked_date',
          label: 'Ngày khoá số',
          show: true
        },
        {
          key: 'cancel_date',
          label: 'Ngày huỷ số',
          show: true
        },
        {
          key: 'has_fee_date',
          label: 'Ngày phát sinh chi phí',
          show: true
        },
        {
          key: 'main_phone_number',
          label: 'Số chủ',
          show: true
        },
        {
          key: 'phone_number',
          label: 'Số thành viên',
          show: true
        },
        {
          key: 'phone_status',
          label: 'Trạng thái số',
          show: true
        },
        {
          key: 'age',
          label: 'Tuổi thọ của số',
          show: true
        },
        {
          key: 'lock_count',
          label: 'Số lần khoá số',
          show: true
        },
        {
          key: 'fee_type',
          label: 'Loại phí',
          show: true
        },
        {
          key: 'provider',
          label: 'Nhà cung cấp',
          show: true
        },
        {
          key: 'legal',
          label: 'Pháp nhân',
          show: true
        },
        {
          key: 'customer',
          label: 'KH sử dụng',
          show: true
        },
        {
          key: 'device',
          label: 'Thiết bị',
          show: true
        },
        {
          key: 'port',
          label: 'Port',
          show: true
        },
        {
          key: 'pics',
          label: 'Nhân viên kĩ thuật',
          show: true
        },
        {
          key: 'sale_pics',
          label: 'Nhân viên chăm sóc',
          show: true
        },
        {
          key: 'viettel_using_status',
          label: 'Trạng thái sử dụng Viettel',
          show: true
        },
        {
          key: 'mobifone_using_status',
          label: 'Trạng thái sử dụng Mobifone',
          show: true
        },
        {
          key: 'vinaphone_using_status',
          label: 'Trạng thái sử dụng Vinaphone',
          show: true
        },
        {
          key: 'other_using_status',
          label: 'Trạng thái sử dụng Ngoại mạng',
          show: true
        },
        {
          key: 'viettel_unlocking_status',
          label: 'Trạng thái khóa số Viettel',
          show: true
        },
        {
          key: 'mobifone_unlocking_status',
          label: 'Trạng thái khóa số Mobifone',
          show: true
        },
        {
          key: 'vinaphone_unlocking_status',
          label: 'Trạng thái khóa số Vinaphone',
          show: true
        },
        {
          key: 'other_unlocking_status',
          label: 'Trạng thái khóa số Ngoại mạng',
          show: true
        }
      ],
      configItems: [
        {
          key: 'id',
          label: 'STT',
          show: true
        },
        {
          key: 'phone_number',
          label: 'Số điện thoại',
          show: true
        },
        {
          key: 'main_phone_number',
          label: 'Số chủ',
          show: true
        },
        {
          key: 'provider',
          label: 'Nhà cung cấp',
          show: true
        },
        {
          key: 'legal',
          label: 'Pháp nhân',
          show: true
        },
        {
          key: 'pickup_date',
          label: 'Ngày lấy',
          show: true
        },
        {
          key: 'client_use_date',
          label: 'Ngày khách lấy',
          show: true
        },
        {
          key: 'phone_number_client',
          label: 'KH sử dụng',
          show: true
        },
        {
          key: 'brand',
          label: 'Brand',
          show: true
        },
        {
          key: 'device',
          label: 'Thiết bị',
          show: true
        },
        {
          key: 'port',
          label: 'Port',
          show: true
        },
        {
          key: 'phone_number_status',
          label: 'Trạng thái số',
          show: true
        },
        {
          key: 'lock_provider',
          label: 'Mạng bị khoá',
          show: true
        },
        {
          key: 'open_provider',
          label: 'Mạng mở',
          show: true
        },
        {
          key: 'using_provider',
          label: 'Mạng đang sử dụng',
          show: true
        },
        {
          key: 'lock_histories',
          label: 'Thông tin khoá số',
          show: true,
          tdClass: 'padding-0'
        },
        {
          key: 'age',
          label: 'Tuổi thọ của số',
          show: true
        },
        {
          key: 'cancel_date',
          label: 'Ngày huỷ',
          show: true
        },
        {
          key: 'provider_cancel_date',
          label: 'Ngày báo NCC huỷ',
          show: true
        },
        {
          key: 'sale_pics',
          label: 'Nhân viên chăm sóc',
          show: true
        },
        {
          key: 'pic_id',
          label: 'Nhân viên kĩ thuật',
          show: true
        }
      ],
      originFields: [
        {
          key: 'row_selected',
          label: 'Chọn',
          thClass: 'text-center',
          show: true
        },
        {
          key: 'phone_number',
          label: 'Số điện thoại',
          show: true
        },
        {
          key: 'main_phone_number',
          label: 'Số chủ',
          show: true
        },
        {
          key: 'provider',
          label: 'NCC',
          show: true
        },
        {
          key: 'legal',
          label: 'Pháp nhân',
          show: true
        },
        {
          key: 'pickup_date',
          label: 'Ngày lấy',
          show: true
        },
        {
          key: 'client_use_date',
          label: 'Ngày khách lấy',
          show: true
        },
        {
          key: 'phone_number_client',
          label: 'KH sử dụng',
          show: true
        },
        {
          key: 'brand',
          label: 'Brand',
          show: true
        },
        {
          key: 'device',
          label: 'Thiết bị',
          show: true
        },
        {
          key: 'port',
          label: 'Port',
          show: true
        },
        {
          key: 'phone_number_status',
          label: 'Trạng thái số',
          show: true
        },
        {
          key: 'lock_provider',
          label: 'Mạng bị khoá',
          show: true
        },
        {
          key: 'open_provider',
          label: 'Mạng mở',
          show: true
        },
        {
          key: 'using_provider',
          label: 'Mạng đang sử dụng',
          show: true
        },
        {
          key: 'lock_histories',
          label: 'Lịch sử khoá số',
          show: true,
          tdClass: 'padding-0'
        },
        {
          key: 'age',
          label: 'Tuổi thọ của số',
          show: true
        },
        {
          key: 'cancel_date',
          label: 'Ngày huỷ',
          show: true
        },
        {
          key: 'provider_cancel_date',
          label: 'Ngày báo NCC huỷ',
          show: true
        },
        {
          key: 'sale_pics',
          label: 'Nhân viên chăm sóc',
          show: true
        },
        {
          key: 'pic_id',
          label: 'Nhân viên kĩ thuật',
          show: true
        }
      ],
      showConfigTable: false,
      fields: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      sumValue: 0,
      pageSizes: [
        {text: 1000, value: 1000},
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      statusPhoneNumberId: {
        LOCKED: 0,
        MONITORING: 0,
        FALSE_POSITIVE: 0,
        NEW: 0,
        QUALIFIED: 0,
        UNQUALIFIED: 0,
        RETEST: 0,
        UNLOCKED: 0,
        WAIT_CANCEL: 0,
        NOT_USE: 0,
        USING: 0,
        AVAILABLE: 0
      },
      isEditable: true,
      items: [],
      selectedId: null,
      selected: [],
      company: null,
      isTechnicalStaff: false,
      providersList: [],
      phoneStatusList: [],
      moveStatusList: [],
      phoneClientsList: [],
      mainPhoneNumberList: [],
      legalList: [],
      bulkUpdateStatusData: null,
      importFile: null,
      isBulkUpdateAll: false,
      users: [],
      customers: [],
      phoneNumberStatus: [],
      saleUsers: [],
      disableSearchPic: false,
      groupUser: [],
      groupSaleUser: [],
      groupStatus: [],
      loadingSaleUser: false,
      loadingUser: false,
      loadingStatus: false,
      groupCustomers: [],
      loadingCustomer: false,
      numberOfUser: 2,
      statistic: {
        age_avg: 0,
        total_init_fee: 0,
        total_operate_fee: 0,
        total_open_fee: 0,
        total_other_fee: 0,
        technical_staff: []
      },
      checkAll: false,
    }
  },
  onResizeScreen () {
    if (window.innerWidth < 1550) {
      this.numberOfUser = 1
    } else {
      this.numberOfUser = 2
    }
  },
  created () {
    this.fields = this.originFields
    window.addEventListener('resize', this.onResizeScreen)
  },
  methods: {
    isAdmin () {
      return Utils.isAdminUser(this.userInfo)
    },
    onRowSelected (items) {
      this.selected = items
    },
    onDoubleClicked (item) {
      this.detail(item.id)
    },
    detail (id) {
      this.selectedId = id
      this.$bvModal.show('phoneNumberDetail')
    },
    toggleColumnSearchForm (event, key) {
      this.configSearchItems = this.configSearchItems.map(field => {
        if (field.key === key) {
          return {...field, show: event}
        }
        return field
      })
      localStorage.setItem(LOCAL_STORAGE_KEY.PHONE_NUMBER_SEARCH_ITEMS, JSON.stringify(this.configSearchItems))
    },
    getFilterRequest () {
      return {
        phone_number: this.filterData.phone_number,
        pickup_date_from: this.filterData.pickup_date ? this.filterData.pickup_date[0] : null,
        pickup_date_to: this.filterData.pickup_date ? this.filterData.pickup_date[1] : null,
        client_use_date_from: this.filterData.client_use_date ? this.filterData.client_use_date[0] : null,
        client_use_date_to: this.filterData.client_use_date ? this.filterData.client_use_date[1] : null,
        lock_date_from: this.filterData.locked_date ? this.filterData.locked_date[0] : null,
        lock_date_to: this.filterData.locked_date ? this.filterData.locked_date[1] : null,
        cancel_date_from: this.filterData.cancel_date ? this.filterData.cancel_date[0] : null,
        cancel_date_to: this.filterData.cancel_date ? this.filterData.cancel_date[1] : null,
        payment_date_from: this.filterData.has_fee_date ? this.filterData.has_fee_date[0] : null,
        payment_date_to: this.filterData.has_fee_date ? this.filterData.has_fee_date[1] : null,
        main_phone_number_id_list: this.filterData.main_phone_number ? this.filterData.main_phone_number.map(item => item.value) : [],
        provider_id_list: this.filterData.provider ? this.filterData.provider.map(item => item.value) : [],
        legal_id_list: this.filterData.legal ? this.filterData.legal.map(item => item.value) : [],
        phone_number_client_list: this.filterData.customers ? this.filterData.customers.map(item => item.code) : [],
        phone_number_status_id_list: this.filterData.phone_status ? this.filterData.phone_status.map(item => item.code) : [],
        phone_number_avg_age: this.filterData.phone_number_avg_age,
        lock_count: this.filterData.number_of_locked ? this.filterData.number_of_locked.value : 0,
        lock_count_type: this.filterData.lock_count_type.map(item => item.value),
        fee_type_list: [],
        pics: this.filterData.pics.map(item => item.code),
        sale_pics: this.filterData.sale_pics.map(item => item.code),
        viettel_using_status: this.filterData.viettel_using_status ? this.filterData.viettel_using_status.value : null,
        mobifone_using_status: this.filterData.mobifone_using_status ? this.filterData.mobifone_using_status.value : null,
        vinaphone_using_status: this.filterData.vinaphone_using_status ? this.filterData.vinaphone_using_status.value : null,
        other_using_status: this.filterData.other_using_status ? this.filterData.other_using_status.value : null,
        viettel_unlocking_status: this.filterData.viettel_unlocking_status ? this.filterData.viettel_unlocking_status.value : null,
        mobifone_unlocking_status: this.filterData.mobifone_unlocking_status ? this.filterData.mobifone_unlocking_status.value : null,
        vinaphone_unlocking_status: this.filterData.vinaphone_unlocking_status ? this.filterData.vinaphone_unlocking_status.value : null,
        other_unlocking_status: this.filterData.other_unlocking_status ? this.filterData.other_unlocking_status.value : null,
        device: this.filterData.device,
        port: this.filterData.port
      }
    },
    filter () {
      if (this.loading) {
        return
      }
      this.selectedId = null
      this.loading = true
      PhoneNumberAPI.filter(this.getFilterRequest(), this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
        this.sumValue = res.data.data.sum_value
        this.items.forEach(item => {
          let age
          if (!item.active_date) {
            age = 0
          } else {
            let lastDate = item.cancel_date ? item.cancel_date : new Date()
            age = moment(lastDate).diff(item.active_date, 'days') + 1
          }
          item.age = age
        })
        PhoneNumberAPI.getStatisticPhoneNumber(this.getFilterRequest(), this.currentPage - 1, this.pageSize).then(
          res => {
            this.statistic = res.data.data
          }
        ).catch(err => {
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        })
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    filterUser (query) {
      this.loadingUser = true
      UserApi.findTechnicalStaffByName(query, this.company.id, 0, MAX_SALE_USER_NUMBER).then(res => {
        this.users = res.data.data.records.map(item => {
          return {'name': item.username, 'code': item.id}
        })

        this.users.unshift({
          'name': 'Chưa gán kĩ thuật',
          'code': null
        })

        this.filterData.pics = this.users

        this.groupUser = [
          {
            label: 'Tất cả',
            users: this.users
          }
        ]
        this.loadingUser = false
        this.filter()
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingUser = false
      })

      this.loadingSaleUser = true
      UserApi.findSaleByName(query, this.company.id, 0, MAX_SALE_USER_NUMBER).then(res => {
        if (!this.isSale(res.data.data.records)) {
          this.saleUsers = res.data.data.records.map(item => {
            return {'name': item.username, 'code': item.id}
          })

          this.saleUsers.unshift({
            'name': 'Chưa gán nhân viên chăm sóc',
            'code': null
          })
        } else {
          this.disableSearchPic = true
          this.saleUsers.push({'name': this.userInfo.username, 'code': this.userInfo.id})
        }

        this.filterData.sale_pics = this.saleUsers

        this.groupSaleUser = [
          {
            label: 'Tất cả',
            users: this.saleUsers
          }
        ]
        this.loadingSaleUser = false
        this.filter()
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingSaleUser = false
      })

      this.loadingCustomer = true
      // const response = await PhoneNumberClientAPI.filter({}, 0, 100)
      // return response.data.data.records
      PhoneNumberClientAPI.filter({}, 0, MAX_SALE_USER_NUMBER).then(res => {
        this.customers = res.data.data.records.map(item => {
          return {'name': item.name, 'code': item.id}
        })

        this.customers.unshift({
          'name': 'Chưa gán KH sử dụng',
          'code': null
        })

        this.filterData.customers = this.customers

        this.groupCustomers = [
          {
            label: 'Tất cả',
            customers: this.customers
          }
        ]
        this.loadingCustomer = false
        this.filter()
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingCustomer = false
      })

      this.loadingStatus = true
      PhoneNumberStatusAPI.filter({}, 0, MAX_SALE_USER_NUMBER).then(res => {
        this.phoneNumberStatus = res.data.data.records.map(item => {
          return {'name': item.name, 'code': item.id}
        })

        this.filterData.phone_status = this.phoneNumberStatus

        this.groupStatus = [
          {
            label: 'Tất cả',
            status: this.phoneNumberStatus
          }
        ]
        this.loadingStatus = false
        this.filter()
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingStatus = false
      })
    },
    isSale (saleUsers) {
      return saleUsers.find(item => item.id === this.userInfo.id) !== undefined
    },
    search () {
      this.filter()
    },
    copyAllPhoneNumber () {
      if (this.loading) {
        return
      }
      this.loading = true
      PhoneNumberAPI.copyPhoneNumber(this.getFilterRequest(), this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        navigator.clipboard.writeText(res.data.data)
        Utils.successToast(this.$bvToast, 'Copy số điện thoại', 'Copy số điện thoại thành công')
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    exportPhoneNumber () {
      if (this.loading) {
        return
      }
      this.loading = true
      PhoneNumberAPI.export(this.getFilterRequest()).then(res => {
        this.loading = false
        let filename = res.data.data.file
        window.location.href = 'https://crm.ity.vn' + filename
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    importPhoneNumber () {
      this.$bvModal.show('importModal')
    },
    handleImportPhoneNumber () {
      if (this.importFile) {
        if (this.file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          Utils.warnToast(this.$bvToast, 'Định dạng file không đúng', 'Vui lòng tải lên file có định dạng xslt')
        } else {
          const formData = new FormData()
          formData.append('company_id', this.company.id)
          formData.append('file', this.importFile)
          PhoneNumberAPI.importPhoneNumber(formData).then(res => {
            Utils.successToast(this.$bvToast, 'Thông báo', 'Tải lên thành công')
            this.filter()
          }).catch(err => {
            Utils.handleError(this.$bvToast, err)
          })
        }
      } else {
        Utils.warnToast(this.$bvToast, 'Chưa chọn file', 'Vui lòng tải lên file')
      }
    },
    closeImportModal () {
      this.$bvModal.hide('importModal')
    },
    bulkUpdateStatus () {
      this.isBulkUpdateAll = true
      this.$bvModal.show('bulkUpdateModal')
    },
    markDeleteSelected () {
      if (this.selected.length === 0) {
        Utils.failedToast(this.$bvToast, 'Dữ liệu không hợp lệ', 'Bạn chưa chọn số')
        return
      }
      this.$bvModal.msgBoxConfirm('Bạn có chắc không?', {
        title: false,
        buttonSize: 'sm',
        centered: true,
        size: 'sm',
        footerClass: 'p-2'
      }).then(res => {
        if (res) {
          const idList = this.selected.map(item => item.id)

          this.loading = true
          PhoneNumberAPI.updateListPhoneNumberStatus(idList, 0, [], true).then(res => {
            this.loading = false
            Utils.successToast(this.$bvToast)
            this.filter()
          }).catch(err => {
            this.loading = false
            Utils.handleError(this.$bvToast, err)
          })
        }
      })
    },
    bulkUpdateSelectedStatus () {
      if (this.selected.length === 0) {
        Utils.failedToast(this.$bvToast, 'Dữ liệu không hợp lệ', 'Bạn chưa chọn số')
        return
      }

      this.isBulkUpdateAll = false
      this.$bvModal.show('bulkUpdateModal')
    },
    addPhoneNumber () {
      this.selectedId = null
      this.$bvModal.show('phoneNumberDetail')
    },
    isShowSearch (key) {
      const item = this.configSearchItems.find(item => item.key === key)
      if (item) {
        return item.show
      }
      return false
    },
    toggleColumn (event, key) {
      this.originFields = this.originFields.map(field => {
        if (field.key === key) {
          return {...field, show: event}
        }
        return field
      })
      this.fields = this.originFields.filter(item => item.show)

      this.configItems = this.configItems.map(field => {
        if (field.key === key) {
          return {...field, show: event}
        }
        return field
      })
      localStorage.setItem(LOCAL_STORAGE_KEY.PHONE_NUMBER_COLUMN_SHOW, JSON.stringify(this.configItems))
    },
    hideModal (modalId) {
      this.selectedId = null
      this.$bvModal.hide(modalId)
    },
    hasEditPermission () {
      return Utils.isAdminUser(this.userInfo) || this.editPermission.includes(PERMISSION_KEY.PHONE_NUMBER_MANAGER) || this.editPermission.includes(PERMISSION_KEY.PHONE_NUMBER_TECHNICAL) || this.editPermission.includes(PERMISSION_KEY.PHONE_NUMBER_ADMIN)
    },
    async getLegal () {
      const response = await LegalAPI.filter({}, 0, 300)
      return response.data.data.records
    },
    async getMainPhoneNumber () {
      const response = await MainPhoneNumberAPI.filter({}, 0, 300)
      return response.data.data.records
    },
    async getPhoneNumberClient () {
      const response = await PhoneNumberClientAPI.filter({}, 0, 300)
      return response.data.data.records
    },
    async getPhoneNumberStatus () {
      const response = await PhoneNumberStatusAPI.filter({}, 0, 300)
      return response.data.data.records
    },
    async getPhoneNumberProvider () {
      const response = await PhoneNumberProviderAPI.filter({}, 0, 300)
      return response.data.data.records
    },
    async initFilter () {
      return Promise.all([this.getLegal(), this.getMainPhoneNumber(), this.getPhoneNumberClient(),
        this.getPhoneNumberStatus(), this.getPhoneNumberProvider()])
        .then(([legals, mainPhoneNumbers, phoneClients, status, providers]) => {
          this.legalList = legals.map(item => {
            return {value: item.id, text: item.name, color: item.color, choose_by_default: item.choose_by_default}
          })
          localStorage.setItem(LOCAL_STORAGE_KEY.LEGAL_LIST, JSON.stringify(this.legalList))
          this.mainPhoneNumberList = mainPhoneNumbers.map(item => {
            return {value: item.id, text: item.name, color: item.color, choose_by_default: item.choose_by_default}
          })
          localStorage.setItem(LOCAL_STORAGE_KEY.MAIN_PHONE_NUMBER_LIST, JSON.stringify(this.mainPhoneNumberList))
          this.phoneClientsList = phoneClients.map(item => {
            return {value: item.id, text: item.name, color: item.color, choose_by_default: item.choose_by_default, pic_name: item.pic_name}
          })
          localStorage.setItem(LOCAL_STORAGE_KEY.PHONE_NUMBER_CLIENT, JSON.stringify(this.phoneClientsList))
          this.phoneStatusList = status.map(item => {
            return {value: item.id, text: item.name, color: item.color, choose_by_default: item.choose_by_default}
          })
          this.moveStatusList = this.phoneStatusList
          localStorage.setItem(LOCAL_STORAGE_KEY.PHONE_STATUS_LIST, JSON.stringify(this.phoneStatusList))
          this.providersList = providers.map(item => {
            return {value: item.id, text: item.name, color: item.color, choose_by_default: item.choose_by_default}
          })
          localStorage.setItem(LOCAL_STORAGE_KEY.PROVIDER_LIST, JSON.stringify(this.providersList))
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
    },
    buildPhoneClient (value) {
      return this.phoneClientsList.find(item => item.value === value)
    },
    buildStatus (value) {
      return this.phoneStatusList.find(item => item.value === value)
    },
    buildLegal (value) {
      return this.legalList.find(item => item.value === value)
    },
    buildProvider (value) {
      return this.providersList.find(item => item.value === value)
    },
    generateTag (selectedRow) {
      if (selectedRow) {
        const text = selectedRow.text
        const color = selectedRow.color
        return [{text: text, color: color}]
      }
    },
    buildMainPhoneNumber (value) {
      return this.mainPhoneNumberList.find(item => item.value === value)
    },
    saveBulkUpdate () {
      if (this.loading) {
        return
      }
      this.loading = true
      let telcoList = []
      if (this.bulkUpdateStatusProvider.Viettel) {
        telcoList.push('Viettel')
      }
      if (this.bulkUpdateStatusProvider.Mobifone) {
        telcoList.push('Mobifone')
      }
      if (this.bulkUpdateStatusProvider.Vinaphone) {
        telcoList.push('Vinaphone')
      }
      if (this.bulkUpdateStatusProvider.Other) {
        telcoList.push('Other')
      }
      if (this.isBulkUpdateAll) {
        PhoneNumberAPI.bulkUpdateStatus(this.getFilterRequest(), this.bulkUpdateStatusData ? this.bulkUpdateStatusData.value : 0, telcoList).then(res => {
          this.loading = false
          this.$bvModal.hide('bulkUpdateModal')
          Utils.successToast(this.$bvToast)
          this.filter()
        }).catch(err => {
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        })
      } else {
        const idList = this.selected.map(item => item.id)
        PhoneNumberAPI.updateListPhoneNumberStatus(idList, this.bulkUpdateStatusData ? this.bulkUpdateStatusData.value : 0, telcoList).then(res => {
          this.loading = false
          this.$bvModal.hide('bulkUpdateModal')
          Utils.successToast(this.$bvToast)
          this.filter()
        }).catch(err => {
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        })
      }
    },
    getTechnicalStaffStatistic () {
      const staffList = this.statistic.technical_staff.map(staff => `${staff.user}(${staff.count})`)
      return staffList.join(', ')
    },
    getSaleName (item) {
      if (item.phone_number_client) {
        const found = this.phoneClientsList.find(u => u.value === item.phone_number_client)
        if (found !== undefined) {
          return found.pic_name
        }
      }
      return ''
    },
    getTechnicalStaffName (item) {
      if (item.pic_id) {
        const found = this.users.find(u => u.code === item.pic_id)
        if (found !== undefined) {
          return found.name
        }
      }
      return ''
    },
    getLockProviderList (item) {
      try {
        let res = []
        if (item.viettel_using_status === 'LOCK') {
          res.push('Viettel')
        }
        if (item.mobifone_using_status === 'LOCK') {
          res.push('Mobifone')
        }
        if (item.vinaphone_using_status === 'LOCK') {
          res.push('Vinaphone')
        }
        if (item.other_using_status === 'LOCK') {
          res.push('Ngoại mạng')
        }

        return res.join(', ')
      } catch (e) {
        return ''
      }
    },
    getOpenProviderList (item) {
      try {
        let res = []
        if (item.viettel_using_status === 'OPEN') {
          res.push('Viettel')
        }
        if (item.mobifone_using_status === 'OPEN') {
          res.push('Mobifone')
        }
        if (item.vinaphone_using_status === 'OPEN') {
          res.push('Vinaphone')
        }
        if (item.other_using_status === 'OPEN') {
          res.push('Ngoại mạng')
        }

        return res.join(', ')
      } catch (e) {
        return ''
      }
    },
    getUsingProviderList (item) {
      try {
        let res = []
        if (item.viettel_using_status === 'USING') {
          res.push('Viettel')
        }
        if (item.mobifone_using_status === 'USING') {
          res.push('Mobifone')
        }
        if (item.vinaphone_using_status === 'USING') {
          res.push('Vinaphone')
        }
        if (item.other_using_status === 'USING') {
          res.push('Ngoại mạng')
        }

        return res.join(', ')
      } catch (e) {
        return ''
      }
    },
    onCheckAll (event) {
      if (this.checkAll === 'check_all') {
        this.$refs.selectableTable.selectAllRows()
      } else {
        this.$refs.selectableTable.clearSelected()
      }
    },
    toggleRow (row) {
      if (row.rowSelected) {
        this.$refs.selectableTable.selectRow(row.index)
      } else {
        this.$refs.selectableTable.unselectRow(row.index)
      }
    },
    onClickPhoneNumber (item) {
      console.log(item)
      navigator.clipboard.writeText(item)
    },
    initStatusId () {
      let id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.LOCKED)
      if (id !== undefined) {
        this.statusPhoneNumberId.LOCKED = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.MONITORING)
      if (id !== undefined) {
        this.statusPhoneNumberId.MONITORING = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.FALSE_POSITIVE)
      if (id !== undefined) {
        this.statusPhoneNumberId.FALSE_POSITIVE = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.NEW)
      if (id !== undefined) {
        this.statusPhoneNumberId.NEW = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.QUALIFIED)
      if (id !== undefined) {
        this.statusPhoneNumberId.QUALIFIED = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.UNQUALIFIED)
      if (id !== undefined) {
        this.statusPhoneNumberId.UNQUALIFIED = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.RETEST)
      if (id !== undefined) {
        this.statusPhoneNumberId.RETEST = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.UNLOCKED)
      if (id !== undefined) {
        this.statusPhoneNumberId.UNLOCKED = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.WAIT_CANCEL)
      if (id !== undefined) {
        this.statusPhoneNumberId.WAIT_CANCEL = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.NOT_USE)
      if (id !== undefined) {
        this.statusPhoneNumberId.NOT_USE = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.CONFIRM_CANCEL)
      if (id !== undefined) {
        this.statusPhoneNumberId.CONFIRM_CANCEL = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.CONFIRM_NOT_USE)
      if (id !== undefined) {
        this.statusPhoneNumberId.CONFIRM_NOT_USE = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.USING)
      if (id !== undefined) {
        this.statusPhoneNumberId.USING = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.AVAILABLE)
      if (id !== undefined) {
        this.statusPhoneNumberId.AVAILABLE = id.value
      }

      let allowStatusList = [this.statusPhoneNumberId.MONITORING, this.statusPhoneNumberId.USING, this.statusPhoneNumberId.AVAILABLE]
      if (this.isTechnicalStaff) {
        this.moveStatusList = this.moveStatusList.filter(item => allowStatusList.indexOf(item.value) > -1)
      }
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission'
    ])
  },
  async mounted () {
    this.isEditable = this.hasEditPermission()
    this.company = Utils.getCompanyByUserInfo(this.userInfo)
    this.isTechnicalStaff = Utils.isTechnicalStaff(this.userInfo)
    await this.initFilter()
    this.initStatusId()
    this.filterUser('')
    const phoneNumberSearchItems = localStorage.getItem(LOCAL_STORAGE_KEY.PHONE_NUMBER_SEARCH_ITEMS)
    if (phoneNumberSearchItems) {
      this.configSearchItems = JSON.parse(phoneNumberSearchItems)
    }
    const columnShow = localStorage.getItem(LOCAL_STORAGE_KEY.PHONE_NUMBER_COLUMN_SHOW)
    if (columnShow) {
      this.configItems = JSON.parse(columnShow)

      this.originFields = this.originFields.map(field => {
        let config = this.configItems.find(item => item.key === field.key)
        if (config) {
          return {...field, show: config.show}
        }
        return field
      })
      this.fields = this.originFields.filter(item => item.show)
    }
    this.filter()
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/phone_number_management/PhoneNumberManagementList.vue